if (!customElements.get('product-media-carousel')) {
  customElements.define(
    'product-media-carousel',
    class ProductMediaCarousel extends HTMLElement {
      connectedCallback() {
        this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
        this.handleDesktopBreakpoint = (event) => {
          this.toggleSwiper(event.matches);
        };

        this.desktopMediaQuery.addEventListener(
          'change',
          this.handleDesktopBreakpoint,
        );

        this.toggleSwiper(this.desktopMediaQuery.matches);
        this.trackRecentlyViewed();
      }

      disconnectedCallback() {
        this.desktopMediaQuery?.removeEventListener(
          'change',
          this.handleDesktopBreakpoint,
        );
        this.destroySwiper();
      }

      toggleSwiper(isDesktop) {
        if (isDesktop) {
          this.destroySwiper();
          return;
        }

        this.initSwiper();
      }

      destroySwiper() {
        this.swiperInstance?.destroy(true, true);
        this.swiperInstance = undefined;
      }

      initSwiper() {
        if (this.swiperInstance) return;

        const desktopOnlySlides = this.querySelectorAll(
          '.swiper-slide[data-desktop-only]',
        );

        desktopOnlySlides.forEach((slide) => {
          slide.classList.remove('swiper-slide');
        });

        const hasSeveralSlides = this.querySelectorAll('.swiper-slide').length > 1;

        const options = {
          slidesPerView: 1,
          spaceBetween: 0,
          autoHeight: true,

          pagination: {
            el: this.querySelector('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
          },

          on: {
            init: (swiper) => {
              this.updateFractionPagination(swiper);
            },
            slideChange: (swiper) => {
              this.updateFractionPagination(swiper);
            },
            breakpoint: (swiper) => {
              this.updateFractionPagination(swiper);
            },
            resize: (swiper) => {
              this.updateFractionPagination(swiper);
            },
          },

          breakpoints: hasSeveralSlides
            ? {
                750: {
                  slidesPerView: 2,
                  spaceBetween: 4,
                },
              }
            : {},
        };

        this.swiperInstance = new Swiper(this, options);
      }

      updateFractionPagination(swiper) {
        if (!this.paginationTotal) return;

        this.paginationTotal.textContent = swiper.snapGrid.length;
        this.paginationCurrent.textContent = swiper.snapIndex + 1;
      }

      get paginationTotal() {
        return this.querySelector('.swiper-pagination-total');
      }

      get paginationCurrent() {
        return this.querySelector('.swiper-pagination-current');
      }

      trackRecentlyViewed() {
        const img = document.querySelector('.product__media-image img');
        if (!img) return;

        const STORAGE_KEY = 'recently-viewed-products';
        const MAX_ITEMS = 6;
        const url = window.location.pathname;
        const src = img.currentSrc || img.src;
        const alt = img.alt;

        let items = [];

        try {
          items = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
        } catch {
          items = [];
        }

        items = items.filter((item) => item.url !== url);
        items.unshift({ url, src, alt });
        if (items.length > MAX_ITEMS) items.length = MAX_ITEMS;

        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        } catch {
          console.error(
            'Could not save recently viewed products to sessionStorage',
          );
        }
      }
    },
  );
}
